import React from 'react';

const SvgDoorControls = props => (
  <svg width={'100%'} viewBox="0 0 32 32" {...props}>
    <defs>
      <style>
        {'.door_controls_svg__a{fill:none;stroke:#acacac;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}'}
      </style>
    </defs>
    <g transform="translate(-780)">
      <path
        className="door_controls__a"
        style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
        d="M795 27h-6V3h14v11M792 15h1"
      />
      <path fill="none" d="M780 0h32v32h-32z" />
      <circle
        className="door_controls__a"
        style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
        cx={4}
        cy={4}
        r={4}
        transform="translate(799 20)"
      />
      <path
        className="door_controls__a"
        style={{ stroke: props.color, fill: 'none', strokeWidth: props.stroke || 2 }}
        d="M803 18v2M803 28v2M797 24h2M807 24h2M807.242 19.757l-1.414 1.414M800.171 26.828l-1.414 1.414M798.757 19.757l1.414 1.414M805.828 26.828l1.414 1.414"
      />
    </g>
  </svg>
);

export default SvgDoorControls;
